<template>
  <div class="loginContainer">
    <!-- <img
      src="../../assets/icon_back.png"
      style="width:4rem;height:4rem;position:fixed;top:0;left:3rem;cursor: pointer;"
      @click="$router.back()"
    /> -->
    <div style="height:3.5rem"></div>
    <div class="studentContainer">
      <div
        style="width:100%;height:100%;background:#ffffff;border-radius:2rem;"
      >
        <div
          style="height:4rem;width:100%;text-align:center;line-height:4rem;position:relative;background: #CFEEFF;border-radius: 2rem 2rem 0px 0px;font-size: 2rem;color: #0F85DB;"
        >
          {{ class_name }}
        </div>
        <div
          style="height:calc( 100% - 4rem );border-radius:2rem;overflow:hidden"
        >
          <div style="padding:1rem;height:calc( 100% - 2rem);">
            <div style="width:100%;height:100%;" class="flexBetween">
              <!-- 左侧视频区域 -->
              <div style="width:calc( 100% - 18.1rem );height:100%;">
                <my-video-player
                  ref="my-video-player"
                  :floatVideoListShow="floatVideoListShow"
                  :floatStudentsListShow="floatStudentsListShow"
                  :src="classVideoSrc"
                  @play-next-video="playNextVideo"
                  @play-prev-video="playPrevVideo"
                >
                  <!-- 浮层按钮插槽 -->
                  <div
                    class="fadeIn"
                    style="position:absolute;bottom:6rem;height:calc( 100vh -  5rem );width:100%;top:0;left:0;"
                    @click="$refs['my-video-player'].videoClick()"
                  >
                    <div style="position:relative;width:100%;height:100%">
                      <!-- 返回按钮 -->
                      <img
                        v-if="!floatVideoListShow && !floatStudentsListShow"
                        src="../../assets/icon_back.png"
                        style="width:4rem;height:4rem;position:absolute;top:0;left:3rem;cursor: pointer;"
                        @click="exitFullScreen"
                      />
                      <!-- 查看视频&学生列表 -->
                      <div
                        v-if="!floatVideoListShow && !floatStudentsListShow"
                        style="position:absolute;bottom:1rem;right:1rem;"
                      >
                        <div @click.stop="showFloatVideoList">
                          <img
                            src="../../assets/float_video.png"
                            style="width:6.2rem;cursor: pointer;"
                          />
                        </div>
                        <div
                          @click.stop="showFloatStudentsList"
                          style="margin-top:1rem"
                        >
                          <img
                            src="../../assets/float_students.png"
                            style="width:6.2rem;cursor: pointer;"
                          />
                        </div>
                      </div>
                      <!-- 视频列表 -->
                      <div
                        v-if="floatVideoListShow"
                        style="width:100%;height:100%;position:absolute;top:0;left:0"
                        @click.stop="floatVideoListHide"
                      >
                        <div style="position:relative;width:100%;height:100%">
                          <!-- 返回箭头 -->
                          <div
                            style="position:absolute;top:4.9rem;right:16.3rem;z-index:1;cursor: pointer;"
                          >
                            <img
                              v-if="nowStep > 1"
                              src="../../assets/class_back.png"
                              style="width:2.2rem;cursor: pointer;"
                              @click.stop="changeScroll"
                            />
                          </div>
                          <!-- 上下滚动箭头 -->
                          <div
                            style="position:absolute;top:7.9rem;right:calc( 19.7rem / 2  - 2.55rem );z-index:1;cursor: pointer;"
                            @click.stop="
                              scrollPrevFloatClass('floatClassScroll')
                            "
                          >
                            <img
                              src="../../assets/scroll_arrow_up.png"
                              style="width:5.1rem"
                            />
                          </div>
                          <!-- bottom:4rem; -->
                          <div
                            style="position:absolute;bottom:0rem;right:calc( 19.7rem / 2  - 2.55rem );z-index:1;cursor: pointer"
                            @click.stop="
                              scrollNextFloatClass('floatClassScroll')
                            "
                          >
                            <img
                              src="../../assets/scroll_arrow_down.png"
                              style="width:5.1rem"
                            />
                          </div>

                          <div
                            class="floatVideoList"
                            style="width:19.7rem;height:calc( 100vh - 8rem );position:absolute;top:4rem;right:0rem;background:rgba(0,0,0,0.7);border-radius:2rem 0 0 2rem"
                            @click.stop=""
                          >
                            <div
                              style="height:3.9rem;background:rgba(0,0,0,0.9);border-radius:2rem 0 0 0;"
                              class="flexCenter"
                            >
                              <!-- width:16rem -->
                              <div
                                style="width:10.667rem;height:2.9rem;border-radius:1.5rem;background:rgba(255,255,255,0.2)"
                              >
                                <div style="padding:0.3rem" class="flexAc">
                                  <div
                                    style="width:5.02rem;height:2.4rem;line-height:2.4rem;text-align:center;font-size:1.4rem;cursor: pointer;"
                                    :style="
                                      tabType == 'class'
                                        ? 'color:#0F85DB;background:#ffffff;border-radius:1.2rem;'
                                        : 'color:#ffffff;border-radius:1.2rem;'
                                    "
                                    @click="setTabtype2('class')"
                                  >
                                    {{ nowStep == 4 ? '课件' : '选课' }}
                                  </div>
                                  <div v-if="nowStep==4"
                                    style="width:5.02rem;height:2.4rem;line-height:2.4rem;text-align:center;font-size:1.4rem;cursor: pointer;"
                                    :style="
                                      tabType == 'pic'
                                        ? 'color:#0F85DB;background:#ffffff;border-radius:1.2rem;'
                                        : 'color:#ffffff;border-radius:1.2rem;'
                                    "
                                    @click="setTabtype2('pic')"
                                  >
                                  {{ nowStep == 4 ? '资料' : '范字' }}
                                  </div>
                                  <!-- <div
                                    style="width:5.02rem;height:2.4rem;line-height:2.4rem;text-align:center;font-size:1.4rem;cursor: pointer;"
                                    :style="
                                      tabType == 'error'
                                        ? 'color:#0F85DB;background:#ffffff;border-radius:1.2rem;'
                                        : 'color:#ffffff;border-radius:1.2rem;'
                                    "
                                    @click="setTabtype2('error')"
                                  >
                                    错例
                                  </div> -->
                                </div>
                              </div>
                            </div>
                            <!-- 滚动区域 -->
                            <div
                              style="padding:0 1.5rem;overflow:scroll;position:relative;height:calc( 100% - 4.6rem );"
                              ref="floatClassScroll"
                              class="floatClassScroll"
                            >
                              <div
                                style="width:100%;"
                                ref="floatClassScrollContainer"
                              >
                                <div
                                  v-if="tabType == 'class'"
                                  style="width:100%;height:100%"
                                >
                                  <div
                                    v-if="nowStep == 4"
                                    style="padding-top:1.5rem"
                                  >
                                    <div
                                      v-for="(item, index) in courseDetail"
                                      :key="index"
                                    >
                                      <div
                                        :id="'floatClassItem' + index + index1"
                                        v-for="(item1,
                                        index1) in item.videoList"
                                        :key="index1"
                                        style="margin-bottom:1rem;cursor: pointer;"
                                        :style="
                                          index1 == currVideoIdx
                                            ? 'padding-top:0.7rem'
                                            : ''
                                        "
                                        @click="playVideo(index, index1)"
                                      >
                                        <div
                                          style="box-sizing:border-box;width: 100%;background: #FFFFFF;border-radius: 1rem;position:relative;"
                                          :style="
                                            index1 == currVideoIdx
                                              ? 'border: 0.3rem solid #FFA143;'
                                              : ''
                                          "
                                        >
                                          <img
                                            :src="item1.video_cover"
                                            style="border-radius:0.6rem;width:100%"
                                          />
                                          <!-- 当前播放标签 -->
                                          <img
                                            v-if="index1 == currVideoIdx"
                                            src="../../assets/curr_play.png"
                                            style="width:6rem;position:absolute;left:calc( 50% - 3rem );top:-1rem"
                                          />
                                          <!-- 未播放蒙版 -->
                                          <div
                                            v-else
                                            style="width:100%;height:100%;background:rgba(0,0,0,0.5);position:absolute;top:0;left:0;border-radius:0.6rem"
                                          ></div>
                                        </div>
                                        <div
                                          style="text-align:center;font-size:1.2rem;color:#0F85DB;margin-top:0.3rem"
                                        >
                                          {{ item1.title }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div v-else-if="nowStep == 1">
                                    <div
                                      v-for="(item, index) in goodList"
                                      :key="index"
                                      style="font-size:1.4rem;color:#ffffff;text-align:left;line-height:3.5rem;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;cursor: pointer;"
                                      :style="
                                        index > 0
                                          ? 'border-top:1px solid rgba(255, 255, 255, 0.3)'
                                          : ''
                                      "
                                      @click="getGoodDetail(item.id)"
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>
                                  <div v-else-if="nowStep == 2">
                                    <div
                                      v-for="(item, index) in goodDetail"
                                      :key="index"
                                      style="font-size:1.4rem;color:#ffffff;text-align:left;line-height:3.5rem;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;cursor: pointer;"
                                      :style="
                                        index > 0
                                          ? 'border-top:1px solid rgba(255, 255, 255, 0.3)'
                                          : ''
                                      "
                                      @click="getCourseDetail(item.id)"
                                    >
                                      <!-- {{ item.stroke ? item.stroke + '-' : ''
                          }} -->
                                      {{ item.name }}
                                    </div>
                                  </div>
                                  <div v-else-if="nowStep == 3">
                                    <div
                                      v-for="(item, index) in practiceList"
                                      :key="index"
                                      style="font-size:1.4rem;color:#ffffff;text-align:left;line-height:3.5rem;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;cursor: pointer;"
                                      :style="
                                        index > 0
                                          ? 'border-top:1px solid rgba(255, 255, 255, 0.3)'
                                          : ''
                                      "
                                      @click="
                                        getCoursePractice(item.practice_id)
                                      "
                                    >
                                      {{ item.practice_name }}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  v-if="tabType == 'pic'"
                                  style="width:100%;height:100%"
                                >
                                  <div
                                    v-if="nowStep == '4'"
                                    style="padding-top:1.5rem;display: grid;grid-template-columns: 1fr 1fr;grid-column-gap: 1rem;grid-row-gap: 1rem"
                                  >
                                    <div
                                      @click.stop="
                                        playWorkVideo(item.example.v)
                                      "
                                      v-for="(item, index) in workList"
                                      :key="index"
                                      style="cursor:pointer"
                                    >
                                      <div
                                        style="box-sizing:border-box;background: #FFFFFF;border-radius: 1rem;position:relative;width: 100%"
                                      >
                                        <img
                                          :src="item.example.p"
                                          style="width:100%;border-radius:0.6rem"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else style="padding-top:1.5rem">
                                    <div
                                      v-for="(item, index) in picList"
                                      :key="index"
                                      style="margin-bottom:1rem;cursor: pointer;"
                                      @click.stop="
                                        picMarkShow(item.file, index)
                                      "
                                    >
                                      <div
                                        style="box-sizing:border-box;width: 100%;background: #FFFFFF;border-radius: 1rem;position:relative;"
                                      >
                                        <img
                                          :src="item.file"
                                          style="width:100%;border-radius:0.6rem"
                                        />
                                      </div>
                                      <div
                                        style="text-align:center;font-size:1.4rem;color:#ffffff;margin-top:0.3rem"
                                      >
                                        {{ item.name }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  v-if="tabType == 'error'"
                                  style="width:100%;height:100%"
                                >
                                  <div style="padding-top:1.5rem">
                                    <div
                                      v-for="(item, index) in errorList"
                                      :key="index"
                                      style="margin-bottom:1rem;display: grid;grid-template-columns: 1fr 1fr;grid-column-gap: 1rem;grid-row-gap: 1rem"
                                    >
                                      <div
                                        v-for="(item1, index1) in item"
                                        :key="index1"
                                        style="cursor: pointer;width: 100%;"
                                        @click="
                                          playErrorVideo(
                                            item1.guide.v,
                                            item1.guide.vc
                                          )
                                        "
                                      >
                                        <div
                                          style="box-sizing:border-box;background: #FFFFFF;border-radius: 1rem;position:relative;width: 100%"
                                        >
                                          <img
                                            :src="item1.guide.p"
                                            style="width:100%;border-radius:0.6rem"
                                          />
                                        </div>
                                        <div
                                          style="text-align:center;font-size:1.4rem;color:#ffffff;margin-top:0.3rem"
                                        >
                                          {{ item1.guide.t }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- 底部小字视频 -->
                            <!-- <div
                              style="height:5.3rem;padding:0.65rem 1.15rem"
                              class="flexAc"
                            >
                              <div
                                style="width:100%;height:100%;overflow:scroll"
                                ref="floatWorkScroll"
                                class="floatWorkScroll"
                              >
                                <div
                                  ref="floatWorkScrollContainer"
                                  style="height:100%;white-space: nowrap;"
                                >
                                  <img
                                    v-for="(item, index) in workList"
                                    :key="index"
                                    :src="item.example.p"
                                    style="cursor: pointer;box-sizing:border-box;width:3.9rem;height:3.9rem;border: 1px solid #EA0003;"
                                    :style="
                                      index > 0 ? 'margin-left:0.65rem' : ''
                                    "
                                    @click.stop="playWorkVideo(item.example.v)"
                                  />
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>

                      <!-- 学生列表 -->
                      <div
                        v-if="floatStudentsListShow"
                        style="width:100%;height:100%;position:absolute;top:0;left:0"
                        @click.stop="floatStudentsListHide"
                      >
                        <div
                          style="position:relative;width:100%;height:100%"
                          class="flexCenter"
                        >
                          <div
                            class="studentContainer"
                            style="background:rgba(0, 0, 0, 0)"
                            @click.stop=""
                          >
                            <div
                              style="width:100%;height:100%;background:rgba(0, 0, 0, 0.4);border-radius:2rem;"
                            >
                              <div
                                style="height:4rem;width:100%;text-align:center;line-height:4rem;position:relative;background:rgba(0, 0, 0, 0.7);;border-radius: 2rem 2rem 0px 0px;font-size: 2rem;color: #ffffff;"
                              >
                                {{ class_name }}
                                <img
                                  src="../../assets/icon_task_close_white.png"
                                  style="width: 3rem;height: 3rem;position: absolute;right: 1rem;top: 0.5rem;cursor: pointer"
                                  @click.stop="floatStudentsListHide"
                                />
                              </div>
                              <div
                                style="height:calc( 100% - 4rem );border-radius:2rem;overflow:scroll"
                                ref="floatStudentScroll"
                                class="floatStudentScroll"
                              >
                                <div
                                  style="padding:1rem;display: grid;grid-template-columns: 1fr 1fr 1fr 1fr;grid-column-gap: 1rem;grid-row-gap: 1rem;"
                                  ref="floatStudentScrollContainer"
                                >
                                  <div
                                    v-for="(item, index) in students.filter(
                                      (item) => {
                                        return item.is_signin == 1;
                                      }
                                    )"
                                    :key="'sign' + index"
                                  >
                                    <div
                                      style="width:18.75rem;height:11.4rem;border-radius:1rem;"
                                      :class="
                                        item.is_signin == '1'
                                          ? 'singInBg'
                                          : 'unSingInBg'
                                      "
                                    >
                                      <div
                                        style="height:6.1rem;padding-left:1rem;padding-top:1.1rem;"
                                        class="flexAc"
                                      >
                                        <div
                                          style="background: linear-gradient(0deg, #50B8EF 0%, #16A0E9 100%);border-radius: 50%;height:6.1rem;width:6.1rem"
                                          class="flexCenter"
                                          @click.stop="signIn(item.id)"
                                        >
                                          <img
                                            :src="
                                              item.avatar
                                                ? item.avatar
                                                : require('../../assets/default_avatar.png')
                                            "
                                            style="cursor: pointer;width:5.5rem;height:5.5rem;border-radius:50%"
                                            :style="
                                              item.is_signin == '1'
                                                ? ''
                                                : 'filter: grayscale(100%);'
                                            "
                                          />
                                        </div>
                                        <div
                                          style="width:11rem;text-align:right"
                                        >
                                          <div
                                            style="font-size: 1.4rem;color: #0F85DB;height:2.5rem;line-height:2.5rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                          >
                                            {{ item.nickname }}
                                          </div>
                                          <div
                                            style="border: 1px solid #0F85DB;opacity: 0.2;"
                                          ></div>
                                          <div
                                            class="flexAc"
                                            style="justify-content:flex-end;height:2.5rem;"
                                          >
                                            <img
                                              src="../../assets/icon_coin.png"
                                              style="width:1.8rem;height:1.8rem;margin-right:0.5rem"
                                            />
                                            <div
                                              style="font-size: 1.4rem;color: #0F85DB;"
                                            >
                                              {{ item.coin_num }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style="margin-top:0.6rem;padding:0rem 2rem"
                                        class="flexBetween"
                                      >
                                        <div
                                          class="loginBtn"
                                          @click.stop="showStudentTask(item)"
                                        >
                                          作品
                                        </div>
                                        <div
                                          class="sendSmsBtn flexCenter"
                                          style="position:relative"
                                          @click.stop="
                                            startConfetti($event, item.id)
                                          "
                                        >
                                          <img
                                            :src="
                                              item.is_reward == 0
                                                ? require('../../assets/icon_star_white.png')
                                                : require('../../assets/icon_star_red.png')
                                            "
                                            style="width:1.4rem"
                                          />
                                          <div
                                            v-if="item.is_reward > 0"
                                            style="width: 2.4rem;height: 2.4rem;background: #FFFFFF;border: 0.1rem solid #F04653;border-radius: 50%;
                                          position:absolute;top:-1.2rem;right:-1.2rem;color:#F04652;font-size:1.2rem"
                                          >
                                            +{{ item.is_reward }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    v-for="(item, index) in students.filter(
                                      (item) => {
                                        return item.is_signin == 0;
                                      }
                                    )"
                                    :key="'unsign' + index"
                                    style="cursor: pointer"
                                    @click="signIn(item.id)"
                                  >
                                    <div
                                      style="width:18.75rem;height:11.4rem;border-radius:1rem;"
                                      :class="
                                        item.is_signin == '1'
                                          ? 'singInBg'
                                          : 'unSingInBg'
                                      "
                                    >
                                      <div
                                        style="height:6.1rem;padding-left:1rem;padding-top:1.1rem;"
                                        class="flexAc"
                                      >
                                        <div
                                          style="background: #999999;border-radius: 50%;height:6.1rem;width:6.1rem"
                                          class="flexCenter"
                                        >
                                          <img
                                            :src="
                                              item.avatar
                                                ? item.avatar
                                                : require('../../assets/default_avatar.png')
                                            "
                                            style="cursor: pointer;width:5.5rem;height:5.5rem;border-radius:50%"
                                            :style="
                                              item.is_signin == '1'
                                                ? ''
                                                : 'filter: grayscale(100%);'
                                            "
                                          />
                                        </div>
                                        <div
                                          style="width:11rem;text-align:right"
                                        >
                                          <div
                                            style="font-size: 1.4rem;color: #0F85DB;height:2.5rem;line-height:2.5rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                          >
                                            {{ item.nickname }}
                                          </div>
                                          <div
                                            style="border: 1px solid #0F85DB;opacity: 0.2;"
                                          ></div>
                                          <div
                                            class="flexAc"
                                            style="justify-content:flex-end;height:2.5rem;"
                                          >
                                            <img
                                              src="../../assets/icon_coin.png"
                                              style="width:1.8rem;height:1.8rem;margin-right:0.5rem"
                                            />
                                            <div
                                              style="font-size: 1.4rem;color: #0F85DB;"
                                            >
                                              {{ item.coin_num }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style="margin-top:0.6rem;padding:0rem 2rem"
                                        class="flexBetween"
                                      >
                                        <div
                                          class="loginBtn"
                                          @click.stop="showStudentTask(item)"
                                        >
                                          作品
                                        </div>
                                        <div
                                          class="sendSmsBtn flexCenter"
                                          style="position:relative;filter: grayscale(100%);"
                                          @click.stop=""
                                        >
                                          <img
                                            :src="
                                              item.is_reward == 0
                                                ? require('../../assets/icon_star_white.png')
                                                : require('../../assets/icon_star_red.png')
                                            "
                                            style="width:1.4rem"
                                          />
                                          <div
                                            v-if="item.is_reward > 0"
                                            style="width: 2.4rem;height: 2.4rem;background: #FFFFFF;border: 0.1rem solid #F04653;border-radius: 50%;
                                          position:absolute;top:-1.2rem;right:-1.2rem;color:#F04652;font-size:1.2rem"
                                          >
                                            +{{ item.is_reward }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--                      学生练习-->
                      <student-task ref="student-task"></student-task>
                    </div>
                  </div>
                </my-video-player>
              </div>
              <!-- 右侧操作区域 -->
              <div
                style="width:17.1rem;height:100%;background:#8BDAFB;border-radius:1rem;position: relative"
              >
                <!-- 头部 -->
                <div
                  style="height:3.3rem;background:#0F85DB;border-radius:1rem 1rem 0 0;padding:0rem 0.4rem;width:calc( 100% - 0.8rem )"
                  class="flexBetween"
                >
                  <div>
                    <img
                      v-if="nowStep > 1"
                      src="../../assets/class_back.png"
                      style="width:2.2rem;cursor: pointer;"
                      @click="changeScroll"
                    />
                  </div>
                  <div
                    style="height:2.2rem;border-radius:1.1rem;background:rgba(255,255,255,0.5)"
                  >
                    <div style="padding:0.2rem" class="flexAc">
                      <div
                        style="width:4.3rem;height:1.8rem;line-height:1.8rem;text-align:center;font-size:1.2rem;cursor: pointer;"
                        :style="
                          tabType == 'class'
                            ? 'color:#0F85DB;background:#ffffff;border-radius:0.9rem;'
                            : 'color:#ffffff;border-radius:0.9rem;'
                        "
                        @click="setTabtype('class')"
                      >
                        {{ nowStep == 4 ? '课件' : '选课' }}
                      </div>
                      <div v-if="nowStep==4"
                        style="width:4.3rem;height:1.8rem;line-height:1.8rem;text-align:center;font-size:1.2rem;cursor:pointer "
                        :style="
                          tabType == 'pic'
                            ? 'color:#0F85DB;background:#ffffff;border-radius:0.9rem;'
                            : 'color:#ffffff;border-radius:0.9rem;'
                        "
                        @click="setTabtype('pic')"
                      >
                      {{ nowStep == 4 ? '资料' : '范字' }}
                      </div>
                      <!-- <div
                        v-if="nowStep == 4"
                        style="width:4.3rem;height:1.8rem;line-height:1.8rem;text-align:center;font-size:1.2rem;cursor:pointer "
                        :style="
                          tabType == 'error'
                            ? 'color:#0F85DB;background:#ffffff;border-radius:0.9rem;'
                            : 'color:#ffffff;border-radius:0.9rem;'
                        "
                        @click="setTabtype('error')"
                      >
                        错例
                      </div> -->
                    </div>
                  </div>
                </div>
                <!-- 滚动区域 -->
                <!-- 上下滚动箭头 -->
                <div
                  style="position:absolute;top:3.3rem;left:calc( 50% - 2.55rem );z-index:1"
                  @click="scrollPrev('bScroll')"
                >
                  <img
                    src="../../assets/scroll_arrow_up.png"
                    style="width:5.1rem"
                  />
                </div>
                <!-- :style="nowStep == 4 ? 'bottom:4.6rem;' : 'bottom:0'" -->
                <div
                  style="position:absolute;left:calc( 50% - 2.55rem );z-index:1;bottom:0"
                  @click="scrollNext('bScroll')"
                >
                  <img
                    src="../../assets/scroll_arrow_down.png"
                    style="width:5.1rem"
                  />
                </div>
                <!-- :style="
                    nowStep == 4
                      ? 'height:calc( 100% - 7.9rem );'
                      : 'height:calc( 100% - 3.3rem );'
                  " -->
                <div
                  class="bScroll"
                  style="padding:0 1rem;overflow:scroll;position:relative;height:calc( 100% - 3.3rem )"
                  ref="bScroll"
                >
                  <div style="width:100%;" ref="scrollContainer">
                    <div
                      v-if="tabType == 'class'"
                      style="width:100%;height:100%"
                    >
                      <div v-if="nowStep == 4" style="padding-top:1rem">
                        <div v-for="(item, index) in courseDetail" :key="index">
                          <div
                            :id="'rightVideoItem' + index + index1"
                            v-for="(item1, index1) in item.videoList"
                            :key="index1"
                            style="margin-bottom:1rem;cursor: pointer;"
                            :style="
                              index1 == currVideoIdx ? 'padding-top:0.7rem' : ''
                            "
                            @click="playVideo(index, index1)"
                          >
                            <div
                              style="box-sizing:border-box;width: 100%;background: #FFFFFF;border-radius: 1rem;position:relative;"
                              :style="
                                index1 == currVideoIdx
                                  ? 'border: 0.3rem solid #FFA143;'
                                  : ''
                              "
                            >
                              <img
                                :src="item1.video_cover"
                                style="border-radius:0.6rem;width:100%;"
                              />
                              <!-- 当前播放标签 -->
                              <img
                                v-if="index1 == currVideoIdx"
                                src="../../assets/curr_play.png"
                                style="width:6rem;position:absolute;left:calc( 50% - 3rem );top:-1rem"
                              />
                              <!-- 未播放蒙版 -->
                              <div
                                v-else
                                style="width:100%;height:100%;background:rgba(0,0,0,0.5);position:absolute;top:0;left:0;border-radius:0.6rem"
                              ></div>
                            </div>
                            <div
                              style="text-align:center;font-size:1.2rem;color:#0F85DB;margin-top:0.3rem"
                            >
                              {{ item1.title }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="nowStep == 1">
                        <div
                          v-for="(item, index) in goodList"
                          :key="index"
                          style="font-size:1.4rem;color:#0F85DB;text-align:left;line-height:3.5rem;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;cursor: pointer;"
                          :style="
                            index > 0
                              ? 'border-top:1px solid rgba(15, 133, 219, 0.3)'
                              : ''
                          "
                          @click="getGoodDetail(item.id)"
                        >
                          {{ item.name }}
                        </div>
                      </div>
                      <div v-else-if="nowStep == 2">
                        <div
                          v-for="(item, index) in goodDetail"
                          :key="index"
                          style="font-size:1.4rem;color:#0F85DB;text-align:left;line-height:3.5rem;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;cursor: pointer;"
                          :style="
                            index > 0
                              ? 'border-top:1px solid rgba(15, 133, 219, 0.3)'
                              : ''
                          "
                          @click="getCourseDetail(item.id)"
                        >
                          <!-- {{ item.stroke ? item.stroke + "-" : ""
                          }} -->
                          {{ item.name }}
                        </div>
                      </div>
                      <div v-else-if="nowStep == 3">
                        <div
                          v-for="(item, index) in practiceList"
                          :key="index"
                          style="font-size:1.4rem;color:#0F85DB;text-align:left;line-height:3.5rem;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;cursor: pointer;"
                          :style="
                            index > 0
                              ? 'border-top:1px solid rgba(15, 133, 219, 0.3)'
                              : ''
                          "
                          @click="getCoursePractice(item.practice_id)"
                        >
                          {{ item.practice_name }}
                        </div>
                      </div>
                    </div>
                    <div v-if="tabType == 'pic'" style="width:100%;height:100%">
                      <div
                        v-if="nowStep == '4'"
                        style="padding-top:1rem;display: grid;grid-template-columns: 1fr 1fr;grid-column-gap: 1rem;grid-row-gap: 1rem"
                      >
                        <div
                          @click.stop="
                            playWorkVideo1(item.example.v, item.example.p)
                          "
                          v-for="(item, index) in workList"
                          :key="index"
                          style="cursor: pointer;"
                        >
                          <div
                            style="box-sizing:border-box;width: 100%;background: #FFFFFF;border-radius: 1rem;position:relative;"
                          >
                            <img
                              :src="item.example.p"
                              style="border-radius:0.6rem;width:7rem;height:7rem;"
                            />
                          </div>
                        </div>
                      </div>
                      <div v-else style="padding-top:1rem">
                        <div
                          v-for="(item, index) in picList"
                          :key="index"
                          style="margin-bottom:1rem;cursor: pointer;"
                          @click="picMarkShow(item.file, index, item.id)"
                        >
                          <div
                            style="box-sizing:border-box;width: 100%;background: #FFFFFF;border-radius: 1rem;position:relative;"
                          >
                            <img
                              :src="item.file"
                              style="border-radius:0.6rem;width:15rem;height:8.5rem;"
                            />
                          </div>
                          <div
                            style="text-align:center;font-size:1.2rem;color:#0F85DB;margin-top:0.3rem"
                          >
                            {{ item.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="tabType == 'error'"
                      style="width:100%;height:100%"
                    >
                      <div style="padding-top:1rem">
                        <div
                          v-for="(item, index) in errorList"
                          :key="index"
                          style="margin-bottom:1rem;cursor: pointer;display: grid;grid-template-columns: 1fr 1fr;grid-column-gap: 1rem;grid-row-gap: 1rem"
                        >
                          <div
                            v-for="(item1, index1) in item"
                            :key="index1"
                            @click="
                              playErrorVideo(item1.guide.v, item1.guide.vc)
                            "
                          >
                            <div
                              style="box-sizing:border-box;width: 100%;background: #FFFFFF;border-radius: 1rem;position:relative;"
                            >
                              <img
                                :src="item1.guide.p"
                                style="border-radius:0.6rem;width:7rem;height:7rem;"
                              />
                            </div>
                            <div
                              style="text-align:center;font-size:1.2rem;color:#0F85DB;margin-top:0.3rem"
                            >
                              {{ item1.guide.t }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 底部小字视频 -->
                <!-- <div
                  v-show="nowStep == 4"
                  style="height:4.6rem;padding:0.5rem 1rem"
                >
                  <div
                    style="width:100%;height:100%;overflow:scroll"
                    ref="workScroll"
                    class="workScroll"
                  >
                    <div
                      ref="workScrollContainer"
                      style="height:100%;white-space: nowrap;"
                    >
                      <img
                        v-for="(item, index) in workList"
                        :key="index"
                        :src="item.example.p"
                        style="cursor: pointer; box-sizing:border-box;width:3.4rem;height:3.4rem;border: 1px solid #EA0003;"
                        :style="index > 0 ? 'margin-left:0.5rem' : ''"
                        @click.stop="playWorkVideo(item.example.v)"
                      />
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div style="position:fixed;bottom:4.4rem;right:0.1rem;cursor: pointer;" @click="$router.back()">-->
    <!--      <img src="../../assets/icon_student_list.png" style="width:7.15rem" />-->
    <!--    </div>-->
    <bottom-bar right-bar="student"></bottom-bar>
    <pic-mark
      ref="pic-mark"
      @prev-page="prevPage"
      @next-page="nextPage"
    ></pic-mark>
    <div
      v-if="workVideoShow"
      style="position:fixed;z-index:999999;width:100vw;height:100vh;top:0;left:0;background:rgba(0,0,0,0.5)"
      class="flexCenter"
    >
      <div
        style="width:40rem;height:40rem;background:#ffffff;border-radius:2rem;position:relative"
      >
        <video
          style="width:100%;height:100%;border-radius:2rem;outline:none"
          :loop="true"
          :src="workVideoSrc"
          :poster="workVideoPoster"
          controls
          autoplay
        />
        <img
          src="../../assets/alert_close.png"
          style="width:4rem;height:4rem;position:absolute;top:-2rem;right:-2rem;cursor: pointer;"
          @click.stop="workVideoShow = false"
        />
      </div>
    </div>

    <audio
      src="https://open.xiaobixiezi.com/h5/icon/MP3/lqcoins.mp3"
      :autoplay="false"
      :loop="false"
      :preload="true"
      style="width:0px;height:0px"
      ref="my-audio"
    ></audio>
    <word-pop ref="word-pop"></word-pop>
  </div>
</template>

<script>
import BottomBar from "../../components/BottomBar.vue";
import PicMark from "../../components/PicMark.vue";
import MyVideoPlayer from "../../components/MyVideoPlayer.vue";
import StudentTask from "../../components/StudentTask";
import WordPop from "../../components/WordPopNew.vue";
export default {
  name: "StartClass",
  components: {
    StudentTask,
    BottomBar,
    PicMark,
    MyVideoPlayer,
    WordPop,
  },
  data() {
    return {
      workVideoShow: false,
      workVideoPoster: "",
      workVideoSrc: "",
      tabType: "class",
      currVideoIdx: -1,
      currCourseIdx: -1,
      floatStudentsListShow: false,
      floatVideoListShow: false,
      classVideoSrc: "",
      scrollOptions: {
        showUpArrow: true,
        showDownArrow: true,
        scrollOffset: 0,
        scrollHeight: "auto",
      },
      floatClassScrollOptions: {
        showUpArrow: false,
        showDownArrow: false,
        scrollOffset: 0,
        scrollHeight: "auto",
      },
      floatStudentScrollOptions: {
        showUpArrow: false,
        showDownArrow: false,
        scrollOffset: 0,
        scrollHeight: "auto",
      },
      classLength: 60,
      nowStep: 1,
      goodList: [],
      goodDetail: [],
      courseDetail: [],
      workList: [],
      picList: [],
      students: [],
      errorList: [],
      goods_id: "",
      course_id: "",
      class_name: "",
    };
  },
  mounted() {
    this.getGoodList();
    this.getPicList();
    this.getStudents();
  },
  destroyed() {},
  methods: {
    prevPage(idx) {
      if (idx == 0) return;
      let newIdx = idx - 1;
      this.picMarkShow(this.picList[newIdx].file, newIdx);
    },
    nextPage(idx) {
      if (idx == this.picList.length - 1) return;
      let newIdx = idx + 1;
      this.picMarkShow(this.picList[newIdx].file, newIdx);
    },
    showStudentTask(item) {
      this.$refs["student-task"].show(
        this.$route.query.class_id,
        item.id,
        item.nickname
      );
    },
    floatVideoListHide() {
      this.$refs["my-video-player"].videoClick();
      this.floatVideoListShow = false;
    },
    floatStudentsListHide() {
      this.$refs["my-video-player"].videoClick();
      this.floatStudentsListShow = false;
    },
    exitFullScreen() {
      this.$refs["my-video-player"].exitFullScreen();
    },
    startConfetti(e, id) {
      this.$http
        .post("/api/v2/handwriting/BigScreen/student_reward", {
          class_id: this.$route.query.class_id,
          student_id: id,
        })
        .then((res) => {
          if (res.code == "200") {
            this.$refs["my-audio"].currentTime = 0;
            this.$refs["my-audio"].play();
            let idx = this.students.findIndex((item) => {
              return item.id == id;
            });

            let target = e.target;
            if (target.classList.toString().indexOf("sendSmsBtn") < 0) {
              target = e.target.parentNode;
            }
            let rewardDiv = document.createElement("div");
            rewardDiv.classList = "rewardStar";
            rewardDiv.innerHTML =
              '<img src="' +
              require("../../assets/reward_star.png") +
              '" style="width:10rem;height:10rem"/>';
            let container = document.querySelector(".loginContainer");
            container.appendChild(rewardDiv);
            let imgObj = rewardDiv.querySelector("img");

            let clientRect = target.getBoundingClientRect();
            setTimeout(() => {
              rewardDiv.style.top = clientRect.top + "px";
              rewardDiv.style.left = clientRect.left + "px";
              imgObj.style.width = "1.4rem";
              imgObj.style.height = "1.4rem";
              imgObj.style.marginLeft = "2.7rem";
              imgObj.style.marginTop = "0.5rem";
            }, 2000);

            setTimeout(() => {
              container.removeChild(rewardDiv);
              this.students[idx].is_reward = this.students[idx].is_reward + 1;
            }, 4000);
          }
        });
    },
    getStudents() {
      let class_id = this.$route.query.class_id;
      if (!class_id) return;
      this.$http
        .post("/api/v2/handwriting/BigScreen/get_class_student_list", {
          class_id: this.$route.query.class_id,
        })
        .then((res) => {
          if (res.code == "200") {
            this.class_name = res.data.class_name;
            let list = res.data.list;
            this.students = list || [];
          }
        });
    },
    signIn(id) {
      this.$http
        .post("/api/v2/handwriting/BigScreen/student_signin", {
          class_id: this.$route.query.class_id,
          student_id: id,
        })
        .then((res) => {
          if (res.code == "200") {
            let idx = this.students.findIndex((item) => {
              return item.id == id;
            });
            if (this.students[idx].is_signin == "1") {
              this.students[idx].is_signin = "0";
            } else {
              this.students[idx].is_signin = "1";
            }
          }
        });
    },
    picMarkShow(pic, index, id) {
      this.$refs["my-video-player"].pause();
      this.$refs["pic-mark"].show(pic, index, id);
    },
    getPicList() {
      this.$http
        .post("/api/v2/handwriting/BigScreen/get_data_list", {})
        .then((res) => {
          if (res.code == "200") {
            this.picList = res.data;
          }
        });
    },
    playErrorVideo(videoId, cover) {
      this.$http
        .get("/apipub/handwriting/AliVod/getPlayAddress", {
          params: { videoId: videoId },
        })
        .then((res) => {
          this.$refs["my-video-player"].pause();
          this.workVideoSrc = res.data[0].playURL;
          this.workVideoPoster = cover || res.data[0].CoverURL;
          this.workVideoShow = true;
        });
    },
    playWorkVideo(videoId) {
      this.$http
        .get("/apipub/handwriting/AliVod/getPlayAddress", {
          params: { videoId: videoId },
        })
        .then((res) => {
          this.$refs["my-video-player"].pause();
          this.workVideoSrc = res.data[0].playURL;
          this.workVideoPoster = res.data[0].CoverURL;
          this.workVideoShow = true;
        });
    },
    playWorkVideo1(videoId, poster) {
      this.$http
        .get("/apipub/handwriting/AliVod/getPlayAddress", {
          params: { videoId: videoId },
        })
        .then((res) => {
          this.$refs["my-video-player"].pause();
          console.log(res.data[0]);
          this.$refs["word-pop"].show(
            {
              videoInfo: {
                url: res.data[0].playURL,
                title: "范字视频",
                poster: res.data[0].CoverURL,
              },
              boardInfo: {
                title: "范字板书",
                poster: poster,
              },
            },
            "video"
          );
          // this.$refs["word-pop"].show({
          //   workVideoSrc: res.data[0].playURL,
          //   workVideoPoster: poster,
          // });
          // this.workVideoSrc = res.data[0].playURL;
          // this.workVideoPoster = res.data[0].CoverURL;
          // this.workVideoShow = true;
        });
    },
    playNextVideo(listLoop = false) {
      let idx1 = this.currCourseIdx;
      let idx2 = this.currVideoIdx;
      if (idx2 == this.courseDetail[idx1].videoList.length - 1) {
        if (listLoop) {
          this.playVideo(idx1, 0);
        } else {
          this.$layer.msg("已经是最后一个视频了！");
        }
      } else {
        this.playVideo(idx1, idx2 + 1);
      }
    },
    playPrevVideo() {
      let idx1 = this.currCourseIdx;
      let idx2 = this.currVideoIdx;
      if (idx2 == 0) {
        this.$layer.msg("已经是第一个视频了！");
      } else {
        this.playVideo(idx1, idx2 - 1);
      }
    },
    playVideo(idx1, idx2, firstPause = false) {
      if (this.currVideoIdx == idx2) return;
      this.currCourseIdx = idx1;
      let item = this.courseDetail[idx1].videoList[idx2];
      if (item.type == "video") {
        this.$http
          .get("/apipub/handwriting/AliVod/getPlayAddress", {
            params: { videoId: item.video_id },
          })
          .then((res) => {
            this.$refs["my-video-player"].setVideoOptions(
              res.data[0].playURL,
              item.video_cover || res.data[0].CoverURL
            );
            this.currVideoIdx = idx2;

            if (firstPause) {
              setTimeout(() => {
                this.$refs["my-video-player"].pause();
              }, 1000);
            }
          });
      } else if (item.type == "logic_seq") {
        this.$http
          .get("/apipub/handwriting/AliVod/getPlayAddress", {
            params: { videoId: item.video_id },
          })
          .then((res) => {
            this.$refs["my-video-player"].setCurrtime(
              res.data[0].playURL,
              item.video_cover || res.data[0].CoverURL,
              item.time,
              item.end_time
            );
            this.currVideoIdx = idx2;

            if (firstPause) {
              setTimeout(() => {
                this.$refs["my-video-player"].pause();
              }, 1000);
            }
          });
      }
    },
    getGoodList() {
      this.$http
        .post("/api/v2/handwriting/BigScreen/get_goods_list", {})
        .then((res) => {
          if (res.code == "200") {
            this.goodList = res.data;
            this.nowStep = 1;
            this.$nextTick(() => {
              this.$refs["bScroll"].addEventListener("scroll", (e) => {
                this.scrollOptions.scrollOffset = e.target.scrollTop;
              });
            });
            this.initScroll();
          }
        });
    },
    getGoodDetail(id) {
      this.$http
        .post("/api/v2/handwriting/BigScreen/get_goods_course_list", {
          goods_id: id,
        })
        .then((res) => {
          if (res.code == "200") {
            this.goodDetail = res.data;
            this.nowStep = 2;
            this.initScroll();
            this.goods_id = id;
          }
        });
    },
    getCourseDetail(id) {
      this.$http
        .post("/api/v2/handwriting/BigScreen/get_goods_course_practice_list", {
          goods_id: this.goods_id,
          course_id: id,
        })
        .then((res) => {
          if (res.code == "200") {
            this.practiceList = res.data;
            this.nowStep = 3;
            this.initScroll();
            this.course_id = id;
          }
        });
    },
    getCoursePractice(id) {
      this.$http
        .post("/api/v2/handwriting/BigScreen/get_course_list", {
          practice_id: id,
          goods_id: this.goods_id,
          course_id: this.course_id,
        })
        .then((res) => {
          if (res.code == "200") {
            let courseDetail = res.data.course_list;
            courseDetail.forEach((item) => {
              let videoList = [];
              // if(item.vedio_2){
              //   videoList.push({
              //     video_id:item.vedio_2,
              //     video_cover:item.vedio_cover,
              //     title:item.title,
              //     type:"video"
              //   })
              // }
              if (item.vedio_1) {
                videoList.push({
                  video_id: item.vedio_1,
                  video_cover: item.v1_c,
                  title: "片头",
                  type: "video",
                });
              }
              if (item.v2_seg) {
                for (let i = 0; i < item.v2_seg.length; i++) {
                  if (item.v2_seg[i].t) {
                    let end_time = "99:59:59";
                    if (item.v2_seg[i + 1] && item.v2_seg[i + 1].t) {
                      end_time = item.v2_seg[i + 1].t;
                    }

                    videoList.push({
                      video_id: item.vedio_2,
                      time: item.v2_seg[i].t,
                      end_time: end_time,
                      video_cover: item.v2_seg[i].i,
                      title: item.v2_seg[i].h || "第" + (i + 1) + "段",
                      type: "logic_seq",
                    });
                  }
                }
              }
              if (item.phy_seg) {
                for (let i = 0; i < item.phy_seg.length; i++) {
                  if (item.phy_seg[i].v) {
                    videoList.push({
                      video_id: item.phy_seg[i].v,
                      video_cover: item.phy_seg[i].i,
                      title: item.phy_seg[i].h,
                      type: "video",
                    });
                  }
                }
              }
              if (
                videoList.length <= 0 ||
                (videoList.length == 1 && videoList[0].title == "片头")
              ) {
                if (item.vedio_2) {
                  videoList.push({
                    video_id: item.vedio_2,
                    video_cover: item.vedio_cover,
                    title: item.title,
                    type: "video",
                  });
                }
              }
              item.videoList = videoList;
            });
            this.courseDetail = courseDetail;
            this.workList = res.data.work_list;
            this.errorList = res.data.error_list;
            this.nowStep = 4;
            this.currVideoIdx = -1;
            this.initScroll();
            this.initWorkScroll();

            let list_loop = localStorage.getItem("list_loop");
            if (
              this.courseDetail.length &&
              this.courseDetail[0].videoList &&
              this.courseDetail[0].videoList.length
            ) {
              if (list_loop === "true") {
                this.playVideo(0, 0);
              } else {
                this.playVideo(0, 0, true);
              }
            }
          }
        });
    },
    showFloatVideoList() {
      this.floatVideoListShow = true;
      this.$refs["my-video-player"].hideFullScreenBar();
      this.$nextTick(() => {
        this.initFloatClassScroll();
        this.initFloatWorkScroll();
      });
    },
    showFloatStudentsList() {
      this.floatStudentsListShow = true;
      this.$refs["my-video-player"].pause();
      this.$refs["my-video-player"].hideFullScreenBar();
      this.$nextTick(() => {
        this.initFloatStudentScroll();
      });
    },
    async changeScroll() {
      if (this.tabType != "class") {
        this.tabType = "class";
      } else {
        this.nowStep--;
      }
      this.initScroll();
    },
    setTabtype2(type) {
      if (this.tabType == type) return;
      this.tabType = type;
      this.initFloatClassScroll();
    },
    setTabtype(type) {
      if (this.tabType == type) return;
      this.tabType = type;
      this.initScroll();
    },
    floatStudentScrollLister(e) {
      this.floatStudentScrollOptions.scrollOffset = e.target.scrollTop;
    },
    async initFloatStudentScroll() {
      this.$refs["floatStudentScroll"].scrollTo(0, 0);
      this.$refs["floatStudentScroll"].removeEventListener(
        "scroll",
        this.floatStudentScrollLister
      );
      this.$refs["floatStudentScroll"].addEventListener(
        "scroll",
        this.floatStudentScrollLister
      );
      this.floatStudentScrollOptions = {
        showUpArrow: false,
        showDownArrow: false,
        scrollOffset: 0,
        scrollHeight: "auto",
      };
    },
    floatClassScrollLister(e) {
      this.floatClassScrollOptions.scrollOffset = e.target.scrollTop;
    },
    async initFloatClassScroll() {
      this.$refs["floatClassScroll"].scrollTo(0, 0);
      this.$refs["floatClassScroll"].removeEventListener(
        "scroll",
        this.floatClassScrollLister
      );
      this.$refs["floatClassScroll"].addEventListener(
        "scroll",
        this.floatClassScrollLister
      );
      this.floatClassScrollOptions = {
        showUpArrow: false,
        showDownArrow: false,
        scrollOffset: 0,
        scrollHeight: "auto",
      };

      if (this.tabType == "class") {
        this.$nextTick(() => {
          let currVideoObj = document.querySelector(
            "#floatClassItem" + this.currCourseIdx + this.currVideoIdx
          );
          this.$refs["floatClassScroll"].scrollTo(0, currVideoObj.offsetTop);
        });
      }
    },
    async initScroll() {
      this.$refs["bScroll"].scrollTo(0, 0);

      this.scrollOptions = {
        showUpArrow: true,
        showDownArrow: true,
        scrollOffset: 0,
      };

      if (
        this.tabType == "class" &&
        this.nowStep == 4 &&
        this.currVideoIdx > -1 &&
        this.currCourseIdx > -1
      ) {
        this.$nextTick(() => {
          let currVideoObj = document.querySelector(
            "#rightVideoItem" + this.currCourseIdx + this.currVideoIdx
          );
          this.$refs["bScroll"].scrollTo(0, currVideoObj.offsetTop);
        });
      }
    },
    async initFloatWorkScroll() {
      this.$refs["floatWorkScroll"].scrollTo(0, 0);
    },
    async initWorkScroll() {
      this.$refs["workScroll"].scrollTo(0, 0);
    },
    scrollPrev(pref) {
      let pobj = this.$refs[pref];
      let ph = pobj.offsetHeight;

      let targetY = 0;
      if (this.scrollOptions.scrollOffset <= ph) {
        targetY = 0;
      } else {
        targetY = this.scrollOptions.scrollOffset - ph;
      }
      pobj.scrollTo(0, targetY);
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOptions.scrollOffset = targetY;
    },
    scrollNext(pref) {
      let pobj = this.$refs[pref];
      let ph = pobj.offsetHeight;
      let sh = pobj.scrollHeight;

      let targetY = 0;
      if (this.scrollOptions.scrollOffset + ph >= sh) {
        targetY = sh - ph;
      } else {
        targetY = this.scrollOptions.scrollOffset + ph;
      }
      pobj.scrollTo(0, targetY);
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOptions.scrollOffset = targetY;
    },
    scrollPrevFloatClass(pref) {
      let pobj = this.$refs[pref];
      let ph = pobj.offsetHeight;

      let targetY = 0;
      if (this.floatClassScrollOptions.scrollOffset <= ph) {
        targetY = 0;
      } else {
        targetY = this.floatClassScrollOptions.scrollOffset - ph;
      }
      pobj.scrollTo(0, targetY);
      // scrollX(pobj,this.scrollOffset, targetX)
      this.floatClassScrollOptions.scrollOffset = targetY;
    },
    scrollNextFloatClass(pref) {
      let pobj = this.$refs[pref];
      let ph = pobj.offsetHeight;
      let sh = pobj.scrollHeight;

      let targetY = 0;
      if (this.floatClassScrollOptions.scrollOffset + ph >= sh) {
        targetY = sh - ph;
      } else {
        targetY = this.floatClassScrollOptions.scrollOffset + ph;
      }
      pobj.scrollTo(0, targetY);
      // scrollX(pobj,this.scrollOffset, targetX)
      this.floatClassScrollOptions.scrollOffset = targetY;
    },
    scrollPrevFloatStudent() {},
    scrollNextFloatStudent() {},
  },
};
</script>
<style scoped>
.floatWorkScroll::-webkit-scrollbar {
  display: none;
}
.floatStudentScroll::-webkit-scrollbar {
  display: none;
}
.floatClassScroll::-webkit-scrollbar {
  display: none;
}
.bScroll::-webkit-scrollbar {
  display: none;
}
.workScroll::-webkit-scrollbar {
  display: none;
}
.sendSmsBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.loginBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: #2a9bff;
}

.loginBtn:hover {
  background: #158ffa;
}
.sendSmsBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.fadeIn {
  animation: fade-in 0.3s ease-in-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.singInBg {
  background: #cfeeff;
}
.unSingInBg {
  background: #eeeeee;
}
.swiper-slide {
  flex-shrink: 1;
}
html {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.loginContainer {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/class_bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.studentContainer {
  width: 80rem;
  height: calc(100vh - 10.4rem);
  padding: 0.5rem;
  margin: 0 auto;
  background: linear-gradient(
    to bottom right,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.7) 100%
  );
  border-radius: 2rem;
}

.classContainer {
  width: 200%;
  position: absolute;
  top: 0;
  left: -50%;
  background: red;
  overflow: hidden;
  border-radius: 0 0 50% 50%;
  background: linear-gradient(
    0deg,
    rgba(15, 133, 219, 0.25) 0%,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0) 100%
  );
}
</style>
